import { useTranslation } from 'react-i18next';

export function useMessengerHelpHint(messenger) {
    const { t } = useTranslation('cards');

    switch (messenger.messenger) {
        case 'whatsapp':
            return messenger.type === 'private'
                ? t('messengerEdit.help.whatsapp.private')
                : t('messengerEdit.help.whatsapp.public');
        case 'telegram':
            return t('messengerEdit.help.telegram');
        case 'messenger':
            return t('messengerEdit.help.messenger');
        case 'vk':
            return t('messengerEdit.help.vk');
        case 'skype':
            return t('messengerEdit.help.skype');
        case 'viber':
            return messenger.type === 'private'
                ? t('messengerEdit.help.viber.private')
                : messenger.type === 'public'
                    ? t('messengerEdit.help.viber.public')
                    : t('messengerEdit.help.viber.community');
    }
}
